import { FileText } from "lucide-react";
import ResourceShellTemplate from "./ResourceShellTemplate";

export default function DocsShell() {
  return (
    <ResourceShellTemplate
      slug="docs"
      eyebrow="Resources · Product Docs"
      title="Ship faster."
      titleAccent="With docs that keep up."
      subtitle="API reference, workspace guides, integration playbooks, and admin console operations — all versioned alongside the engines they describe."
      icon={FileText}
      previewLabel="Doc streams shipping"
      previewItems={[
        { title: "REST API reference — /api/v3/*", desc: "Every endpoint, every schema, every response — auto-generated from the Pydantic models and always current.", meta: "Reference" },
        { title: "Workspace tab authoring guide", desc: "How to build a new plugin tab for the Property Workspace — routing, lifecycle, and RBAC.", meta: "Guides" },
        { title: "Integrations — Stripe, DocuSign, Twilio, Resend", desc: "Setup guides, sandbox keys, and best practices for hardening each provider.", meta: "Integrations" },
        { title: "Admin Console operations", desc: "Managing tenants, roles, feature flags, MFA enforcement, and IP allowlist policies.", meta: "Governance" },
      ]}
    />
  );
}
